import { GetTimeFromTimestamp, MaterialList, MultipleGabeImportJobs } from '@dave/types';
import { LedgerImportStatusEnum } from './ledger-import.entity';

export enum MultipleGabeImportJobsStatusEnum {
    New = 'NEU',
    InProgress = 'IN_BEARBEITUNG',
    Finished = 'ABGESCHLOSSEN',
    Error = 'FEHLER',
    FinishedAssociatedOrderNumberNotFound = 'ABGESCHLOSSEN_ZUGEHOERIGE_BESTELLUNG_NICHT_GEFUNDEN',
    FinishedNoOrderNumberProvided = 'ABGESCHLOSSEN_KEINE_BESTELLUNGNUMMER_ANGEGEBEN',
}
export const MultipleGabeImportJobsStatusNames: Map<MultipleGabeImportJobsStatusEnum, string> = new Map<MultipleGabeImportJobsStatusEnum, string>([
    [MultipleGabeImportJobsStatusEnum.New, 'Neu'],
    [MultipleGabeImportJobsStatusEnum.InProgress, 'In bearbeitung'],
    [MultipleGabeImportJobsStatusEnum.Finished, 'Abgeschlossen'],
    [MultipleGabeImportJobsStatusEnum.Error, 'Fehler beim einspielen'],
    [MultipleGabeImportJobsStatusEnum.FinishedAssociatedOrderNumberNotFound, 'Abgeschlossen, zugehörige Bestellung nicht gefunden'],
    [MultipleGabeImportJobsStatusEnum.FinishedNoOrderNumberProvided, 'Abgeschlossen, keine Bestellnummer in der Datei angegeben'],
]);

export class  MultipleGabeImportJobsEntity {
    constructor(
        public Id: number = null,
        public PartnerId: number = null,
        public Status: MultipleGabeImportJobsStatusEnum = null,
        public VersionId: number = null,
        public Error: string = null,
        public CreatedLedgerImportId: number = null,
        public FoundLedgerImportOrderId: number = null,
        public FoundSupplierId: number = null,
        public FoundCommissionId: number = null,
        public UglTaskFileId: number = null,
        public UpdatedAt: Date = null,
        public CreatedAt: Date = null,
    ) {}

    public static EntityName = 'MultipleGabeImportJobs';
    public Clone(override: Partial<MultipleGabeImportJobsEntity> = {}): MultipleGabeImportJobsEntity {
        const attr = { ...this, ...override };
        return Object.assign(new MultipleGabeImportJobsEntity(), attr);
    }
}

export function MultipleGabeImportJobsEntityFromBackend(res: MultipleGabeImportJobs): MultipleGabeImportJobsEntity {
    const statusEnumValue = res.Status ? MultipleGabeImportJobsStatusEnum[res?.Status] : null;

    return new MultipleGabeImportJobsEntity(
        res.Id && +res.Id,
        res.PartnerId && +res.PartnerId,
        statusEnumValue,
        res.VersionId && +res.VersionId,
        res.Error,
        res.CreatedLedgerImportId && +res.CreatedLedgerImportId,
        res.FoundLedgerImportOrderId && +res.FoundLedgerImportOrderId,
        res.SupplierId && +res.SupplierId,
        res.CommissionId && +res.CommissionId,
        res.UglTaskFileId && +res.UglTaskFileId,
        res.UpdatedAt && GetTimeFromTimestamp(+res.UpdatedAt),
        res.CreatedAt && GetTimeFromTimestamp(+res.CreatedAt),
    );
}
